import { useCallback } from 'react';
import { useUser } from 'common/context/UserContext';
import { useCreateClient } from 'mutations/client';

export const useResolveClient = () => {
  const user = useUser();
  const createClient = useCreateClient();

  return useCallback(
    async client => {
      if (!client) return null;
      if (typeof client !== 'string' && client.id) return client;

      const parts = client.trim().split(/\s+/);
      const firstName = parts[0];
      const lastName = parts.slice(1).join(' ') || firstName;
      const newClient = await createClient.mutateAsync({ firstName, lastName });
      if (!newClient?.id) return null;
      await user.updateClient(newClient);
      return newClient;
    },
    [createClient, user],
  );
};
